import { useMessageCount } from "hooks/useMessageCount";
import { memo } from "react";

const MessageNotifier = () => {
  useMessageCount();
  return null;
};

export default memo(MessageNotifier);
